import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReviewsService {
  constructor(private http: HttpClient) {}
  private readonly baseUrl = environment.apiUrl;
  private readonly companyId = localStorage.getItem('userId') || '';
  createComment(
    data = {
      content: 'Great company to work with! Highly recommended.',
    },
  ) {
    return this.http.post(
      `${this.baseUrl}api/companies/73356b5b-b697-4e7b-bbed-87a4ab535d9f/comments`,
      data,
    );
  }
  getPendingComments(page = 0, size = 10, expired14Days = false) {
    return this.http.get(
      `${this.baseUrl}api/companies/${this.companyId}/comments?page=${page}&size=${size}`,
    );
  }
  getAppovedComment(page = 0, size = 10, expired14Days = false) {
    return this.http.get(
      `${this.baseUrl}api/companies/${this.companyId}/comments/approved?page=${page}&size=${size}&expired14Days=${expired14Days}`,
    );
  }
  getAllComment(page = 0, size = 10, expired14Days = false) {
    return this.http.get(
      `${this.baseUrl}api/companies/${this.companyId}/comments?page=${page}&size=${size}&expired14Days=${expired14Days}`,
    );
  }
  updateCommentStatus(statusObj: { action: string }, commentId: string) {
    return this.http.patch(
      `${this.baseUrl}api/companies/${this.companyId}/comments/${commentId}/review`,
      statusObj,
    );
    // /api/companies/{{companyId}}/comments/{{commentId}}/review
  }

  deleteCommnet(commentId: string) {
    return this.http.delete(
      `${this.baseUrl}api/companies/${this.companyId}/comments/${commentId}`,
    );
  }
  addReplayToComment(replay: { content: string }, commentId: string) {
    return this.http.post(
      `${this.baseUrl}api/comments/${commentId}/replies`,
      replay,
    );
  }
  updateCommentReplay(
    replay: { content: string },
    commentId: string,
    replyId: string,
  ) {
    return this.http.put(
      `${this.baseUrl}api/comments/${commentId}/replies/${replyId}`,
      replay,
    );
  }
  getCommnetReplay(commentId: string) {
    return this.http.get(`${this.baseUrl}api/comments/${commentId}/replies`);
  }
  changeCommentVisibilty(commentId: string) {
    return this.http.patch(
      `${this.baseUrl}api/companies/${this.companyId}/comments/${commentId}/hide`,
      '',
    );
  }
  deleteCommentReplay(commentId: string, replyId: string) {
    return this.http.delete(
      `${this.baseUrl}api/comments/${commentId}/replies/${replyId}`,
    );
  }
}
